import { WelcomeMessageBanner } from "components/ezpay/common/welcome-message-banner/welcome-message-banner";
import { WelcomeModal } from "components/ezpay/common/welcome-modal/welcome-modal";
import { COMMON_NAMESPACE, VALIDATE_NAMESPACE } from "constants/i18n-namespaces";
import { useWelcomeMessage } from "hooks";
import { useTranslation } from "react-i18next";
import { IBiller } from "types/biller";

export interface WelcomeMessageSectionProps {
  biller: IBiller | undefined;
  isMobile: boolean;
}

export const WelcomeMessageSection = ({
  biller,
  isMobile,
}: WelcomeMessageSectionProps): JSX.Element | null => {
  const { t } = useTranslation(VALIDATE_NAMESPACE);
  const {
    shouldShowWelcomeBanner,
    welcomeMessage,
    isWelcomeModalOpen,
    openWelcomeModal,
    closeWelcomeModal,
  } = useWelcomeMessage(biller);

  if (!shouldShowWelcomeBanner) {
    return null;
  }

  return (
    <>
      <div className="welcome-banner-div">
        <WelcomeMessageBanner
          messageLabel={t("welcome-banner-title")}
          linkText={`${t("view", { ns: COMMON_NAMESPACE })}`}
          onClick={openWelcomeModal}
        />
      </div>
      <WelcomeModal
        headingText={t("biller-message-label", {
          billerName: biller?.billerName,
        })}
        open={isWelcomeModalOpen}
        onClose={closeWelcomeModal}
        infoText={welcomeMessage ?? ""}
        closeButtonLabel={`${t("close", { ns: COMMON_NAMESPACE })}`}
      />
    </>
  );
};
